import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";
import { safeJson } from "../utils/safeJson";

let _token = null;
export function setToken(token) { _token = token; }

export async function saveNfeXml(payload) {
  const url = new URL("/nfe/upload-xml", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(_token ? { Authorization: `Bearer ${_token}` } : {}),
    },
    body: JSON.stringify(payload),
  });

  const data = await safeJson(response);

  if (!response.ok) {
    throw new Error(resolveApiMessage(data, "Erro ao salvar XML"));
  }

  return data;
}
